import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './WalletCurrencyRate.module.css';
import { ReactComponent as Coins } from './coins.svg';
import { ReactComponent as Currency } from './currency.svg';

type Props = Overwrite<React.PropsWithoutRef<JSX.IntrinsicElements['section']>, {
  region: Region,
}>;

const baseToken = 1000;

export default function WalletCurrencyRate({ className, region, ...props }: Props) {
  return (
    <section {...props} className={classNames(styles.walletCurrencyRate, className)}>
      <div className={styles.wrapper}>
        <div className={styles.info}>
          <Coins />

          <h3>
            <FormattedMessage
              defaultMessage="{baseToken} Coins"
              values={{
                baseToken,
              }}
            />
          </h3>
        </div>

        <div className={styles.info}>
          <Currency />

          <h3>
            {baseToken * region.exchangeRate}

            {' '}

            {region.currencyCode}
          </h3>
        </div>
      </div>

      <p className={styles.equality}>
        =
      </p>
    </section>
  );
}
